export enum Type {
  POST_TASK_HIDE = 'app/POST-TASK/HIDE',

  POST_TASK_CLEAR = 'app/POST-TASK/CLEAR',
}
